import { unref, computed } from 'vue';import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/loading.png';
const _withScopeId = n => (_pushScopeId("data-v-7c45cf11"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "loading-container"
};
const _hoisted_2 = {
  class: "display-col-center"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
import store from '@/store';
export default {
  __name: 'index',
  setup(__props) {
    const loadingText = computed(() => {
      return store.state.moduleCommon.loadingText || '努力加载中...';
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("span", null, _toDisplayString(_unref(loadingText)), 1)])]);
    };
  }
};